export const isNumber = (value) => {
	return !isNaN(value) && !isNaN(parseFloat(value));
};